import { Loader,} from "@bracket/ui";
import { useVaults, } from "@store";
import type { FunctionComponent, } from "react";
import styled from "styled-components";
import { MetricCards, } from "../../components";
import { BorealSection, } from "./BorealSection";


export const Account: FunctionComponent = () => {

	const {
		ready,
	} = useVaults();

	if(!ready)
		return <Loader center />

	return (
		<AccountContainer>
			<MetricCards />
			<BorealSection />
		</AccountContainer>
	);
};


const AccountContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 20px;
`;
